
import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

@Component({
  computed: {
    ...mapGetters('moduleQuantCart', ['cartItemIds', 'cartWarehouse']),
  },
})
export default class QuantCartWarnings extends Vue {
  private cartItemIds!: number[];
  private cartWarehouse!: string;
}
